var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder center"},[_c('img',{attrs:{"width":"160px","height":"160px","src":_vm.placeholderImg}}),_vm._t("default",[_c('pre',{staticClass:"center text"},[_vm._v(_vm._s(_vm.placeholderText))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }